//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dateFormat, disabledDate } from '@/plugin/format.js'
import { compress } from '@/plugin/imagecompress.js'
import PictureList from '@/components/PictureList.vue'
export default {
  data() {
    const validateCompanyName = (rule, value, callback) => {
      if (this.alertForm.usercompany === 2 && value === '') {
        callback(new Error('请输入单位名称'))
      } else {
        callback()
      }
    }
    return {
      filters: {
        registed: false,
        keyword: '',
        state: ''
      },
      dtypes: [],
      dclassifys: [],
      dmodels: [],
      devicesdata: [],
      dataForm: {
        Id: '',
        dclassify: '',
        dtype: '',
        model: '',
        seriesno: '',
        wlimit: '',
        exwlimit: '',
        pdate: null
      },
      pickerOptions: {
        disabledDate(time) {
          return disabledDate(time)
        }
      },
      editDialogVisible: false, // 新增编辑界面是否显示
      uploadDialogVisible: false,
      alertDialogVisible: false,
      pictureVisible: false,
      dataFormRules: {
        dclassify: [
          { required: true, message: '请输入设备分类', trigger: 'blur' }
        ],
        dtype: [{ required: true, message: '请输入设备种类', trigger: 'blur' }],
        model: [{ required: true, message: '请输入型号', trigger: 'blur' }],
        seriesno: [
          { required: true, message: '请输入系列号', trigger: 'blur' }
        ],
        pdate: [{ required: true, message: '请输入购买日期', trigger: 'blur' }]
      },
      selections: [], // 列表选中列
      registList: [],
      canregistList: [],
      canUploadList: [],
      canDeleteUploadList: [],
      canDeleteList: [],

      picturelist: [],
      uploadpicturelist: [],
      pictureidlist: [],
      fileData: [],
      uploadIdData: [],
      uploadFolderIdData: [],
      isEdit: true,
      isEditPDate: false,
      alertForm: {
        // checkalert: false,
        usercompany: 1,
        companyname: '',
        pdate: null
      },
      alertFormRules: {
        /*  checkalert: [
            { required: true, message: '请输入同意用户协议', trigger: 'blur' }
          ], */

        pdate: [{ required: true, message: '请输入购买日期', trigger: 'blur' }],
        usercompany: [
          { required: true, message: '请选择用户类型', trigger: 'blur' }
        ],
        companyname: [{ validator: validateCompanyName, trigger: 'blur' }]
      }
    }
  },
  methods: {
    getlist: function() {
      let un = sessionStorage.getItem('user')
      let params = {
        UserName: un,
        Keyword: this.filters.keyword.trim()
      }
      if (this.filters.registed) {
        params.State = '已注册'
      } else {
        if (!this.filters.state) {
          params.State = '可注册,未通过,待审核'
        } else {
          params.State = this.filters.state
        }
      }
      this.$api
        .getDevice(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(dev => {
              if (dev.State === '未通过') dev.StateId = 1
              if (dev.State === '可注册') dev.StateId = 2
              if (dev.State === '待审核') dev.StateId = 3
              list.push(dev)
            })
            list.sort((a, b) => a.StateId - b.StateId)
            this.devicesdata = list
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    handleAdd: function() {
      this.editDialogVisible = true
      this.isEdit = false
      this.isEditPDate = false
      this.dataForm = {
        dtype: '',
        model: '',
        dclassify: '',
        seriesno: '',
        pdate: null
      }
    },
    handleEdit: function(dev) {
      this.editDialogVisible = true
      this.isEdit = true
      this.isEditPDate = false
      this.dataForm = {
        id: dev.Id,
        dtype: dev.DType,
        dclassify: dev.DClassify,
        model: dev.Model,
        seriesno: dev.SeriesNO,
        pdate: dev.PDate
      }
    },
    handleDeletePCertificate: function(device) {
      this.canDeleteUploadList = []
      this.canDeleteUploadList.push(device)
      this.handleDeletePCertificateList()
    },
    handleDeletePCertificateList: function() {
      this.$confirm(
        '确认删除' +
          this.canDeleteUploadList.length.toString() +
          '台设备的购买凭证吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        let un = sessionStorage.getItem('user')
        var params = []
        this.canDeleteUploadList.forEach(dev => {
          params.push({
            UserName: un,
            Model: dev.Model,
            SeriesNO: dev.SeriesNO,
            PCertificate: dev.PCertificate
          })
        })
        this.$api.deviceCancelPCertificate(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '设备删除购买凭证成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleDelete: function(device) {
      this.canDeleteList = []
      this.canDeleteList.push(device)
      this.handleDeleteList()
    },
    handleDeleteList: function() {
      this.$confirm(
        '确认删除' +
          this.canDeleteList.length.toString() +
          '台设备进行保修注册吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        let un = sessionStorage.getItem('user')
        var params = []
        this.canDeleteList.forEach(dev => {
          params.push({
            UserName: un,
            Model: dev.Model,
            SeriesNO: dev.SeriesNO
          })
        })
        this.$api.deviceUnRegist(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '设备删除成功',
              type: 'success'
            })
            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleUploadList: function() {
      this.$confirm(
        '确认上传' +
          this.canUploadList.length.toString() +
          '台设备的购买凭证吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        if (this.$refs.uploadfile !== undefined) {
          this.$refs.uploadfile.clearFiles()
        }

        this.canUploadList.forEach(dev => {
          this.uploadIdData.push(dev.Id)
        })
        this.uploadDialogVisible = true
      })
    },
    handleUpload: function(device) {
      if (device !== null) {
        this.uploadIdData = []
        this.uploadFolderIdData = []
        this.uploadpicturelist = []
        this.uploadIdData.push(device.Id)

        if (device.PCertificate === null) {
          this.uploadDialogVisible = true
        } else {
          // 判断凭证是否有其他设备已经提交
          let un = sessionStorage.getItem('user')
          let params = {
            UserName: un,
            PCertificate: device.PCertificate
          }
          this.$api
            .getDevice(params)
            .then(res => {
              if (res.Status === 1) {
                let canupload = true
                res.Entity.forEach(dev => {
                  if (dev.State === '待审核' || dev.State === '已注册') {
                    canupload = false
                    this.$alert(
                      '同批次凭证设备 ' +
                        dev.SeriesNO +
                        ' 已提交注册，无法修改凭证，只能删除凭证!',
                      '错误',
                      {
                        confirmButtonText: '确定'
                      }
                    )
                    return false
                  }
                })
                if (canupload) {
                  this.uploadFolderIdData.push(device.PCertificate)
                  this.$api
                    .getFile(device.PCertificate)
                    .then(res => {
                      if (res.Status === 1) {
                        var list = []
                        res.Entity.forEach(item => {
                          list.push({
                            name: item.FileName,
                            url: 'data:image/png;base64,' + item.Contents,
                            Id: item.Id
                          })
                        })
                        this.uploadpicturelist = list
                        this.uploadDialogVisible = true
                      } else {
                        this.$alert(res.Message, '错误', {
                          confirmButtonText: '确定'
                        })
                      }
                    })
                    .catch(function(res) {
                      this.$alert('获取数据错误！', '错误', {
                        confirmButtonText: '确定'
                      })
                    })
                }
              } else {
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
            .catch(function(res) {
              this.$alert('获取数据错误！', '错误', {
                confirmButtonText: '确定'
              })
            })
        }
      }
    },
    handleScanBarcode: function(params) {
      compress.compressAccurately(params.file, 1024 * 10).then(res => {
        let uploadData = new FormData()
        uploadData.append('file', res)
        this.$api
          .scanBarcode(uploadData)
          .then(res => {
            if (res.Status === 1) {
              let un = sessionStorage.getItem('user')
              let params = {
                UserName: un,
                Model: res.Entity['型号'].trim(),
                SeriesNO: res.Entity['系列号'].trim()
              }
              this.editDialogVisible = true
              this.isEdit = true
              this.isEditPDate = true
              this.dataForm = {
                model: params.Model,
                seriesno: params.SeriesNO,
                pdate: null
              }

              /* this.$api.deviceConfirm(params).then(res => {
                if (res.Status === 1) {
                  this.$message({
                    message: params.Model + ' ' + params.SeriesNO + '提交成功',
                    type: 'success'
                  })

                  this.getlist()
                } else {
                  this.$alert(
                    params.Model + ' ' + params.SeriesNO + ' ' + res.Message,
                    '错误',
                    {
                      confirmButtonText: '确定'
                    }
                  )
                }
              }) */
            } else {
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
            params.onSuccess()
          })
          .catch(function(res) {
            params.onError()
          })
      })
    },
    /*  beforeScanBarcode: function (file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 < 512 // 判定图片大小是否小于0.5mb

        if (isLt2M) {
          resolve(file)
        }

        compress.compressAccurately(file, 512).then(res => {
          res.lastModifiedDate = new Date()
          res.name = file.name
          alert(res)
          resolve(file)
        })
      })
    }, */
    changeUploadFile: function(file, fileList) {
      this.fileData = []
      this.pictureidlist = []
      fileList.forEach(file => {
        if (file.Id !== undefined) {
          this.pictureidlist.push(file.Id)
        } else {
          let isLt2M = file.raw.size / 1024 < 512 // 判定图片大小是否小于0.5mb
          if (isLt2M) {
            this.fileData.push(file.raw)
          } else {
            compress.compressAccurately(file.raw, 512).then(res => {
              this.fileData.push(res)
            })
          }
        }
      })
    },
    submitUploadFile: function() {
      let fromData = new FormData()
      this.uploadIdData.forEach(id => {
        fromData.append('Id', id)
      })
      this.fileData.forEach(file => {
        fromData.append('files', file)
      })
      this.uploadFolderIdData.forEach(id => {
        fromData.append('FolderId', id)
      })
      this.pictureidlist.forEach(id => {
        fromData.append('FileId', id)
      })
      this.$api
        .uploadCertificateFile(fromData)
        .then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '购买凭证提交成功',
              type: 'success'
            })
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
          this.uploadDialogVisible = false
          this.getlist()
        })
        .catch(function(res) {})
    },
    /* handleUploadFile: function (params) { },
    beforeUploadFile: function (file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 < 512 // 判定图片大小是否小于0.5mb

        if (isLt2M) {
          resolve(file)
        }
        // resolve(file)
        compress.compressAccurately(file, 512).then(res => {
          resolve(res)
        })
      })
    }, */
    editRegist: function() {
      this.$refs.alertForm.validate(valid => {
        if (valid) {
          let un = sessionStorage.getItem('user')
          var params = []
          this.canregistList.forEach(dev => {
            params.push({
              UserName: un,
              Model: dev.Model,
              SeriesNO: dev.SeriesNO,
              UserCompany:
                this.alertForm.usercompany === 1
                  ? '个人'
                  : this.alertForm.companyname,
              PDate: this.alertForm.pdate
            })
          })
          this.$api.deviceRegist(params).then(res => {
            if (res.Status === 1) {
              this.$message({
                message: '设备注册成功',
                type: 'success'
              })

              this.getlist()
              this.alertDialogVisible = false
            } else {
              this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
                confirmButtonText: '确定'
              })
            }
          })
        }
      })
    },
    handleRegistList: function() {
      this.$confirm(
        '确认注册' + this.registList.length.toString() + '台设备吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        // this.alertForm.checkalert = false
        this.alertForm.usercompany = 1
        this.alertForm.companyname = ''
        this.alertForm.pdate = null
        this.canregistList = []
        this.registList.forEach(dev => {
          this.canregistList.push(dev)
        })
        this.alertDialogVisible = true
      })
    },
    handleRegist: function(device) {
      // this.alertForm.checkalert = false

      this.alertForm.usercompany = 1
      this.alertForm.companyname = ''
      this.alertForm.pdate = null
      this.canregistList = []
      this.canregistList.push(device)
      this.alertDialogVisible = true
    },
    handleConfirm: function() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {
            cancelButtonClass: 'btn-custom-cancel'
          }).then(() => {
            let un = sessionStorage.getItem('user')
            let params = {
              UserName: un,
              Model: this.dataForm.model,
              SeriesNO: this.dataForm.seriesno,
              PDate: this.dataForm.pdate
            }
            if (this.dataForm.id !== '') params.Id = this.dataForm.id
            this.$api.deviceConfirm(params).then(res => {
              if (res.Status === 1) {
                this.$message({ message: '提交成功', type: 'success' })
                this.editDialogVisible = false
                this.getlist()
              } else {
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
          })
        }
      })
    },
    handleSearch: function() {
      this.getlist()
    },
    handleShowPicture: function(params) {
      this.pictureVisible = true
      this.$api
        .getFile(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(item => {
              list.push('data:image/png;base64,' + item.Contents)
            })
            this.picturelist = list
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    getDType: function() {
      let params = {}
      this.$api
        .selectDType(params)
        .then(res => {
          if (res.Status === 1) {
            this.dtypes = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    dtypeSelectChanged: function(selVal) {
      let params = { DType: this.dataForm.dtype }
      console.log('dtype:' + selVal)
      this.$api
        .selectDClassify(params)
        .then(res => {
          if (res.Status === 1) {
            this.dclassifys = res.Entity
            if (this.dclassifys.indexOf(this.dataForm.dclassify) >= 0) {
            } else {
              this.dataForm.dclassify = ''
              this.dataForm.model = ''
            }
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    dclassifySelectChanged: function(selVal) {
      let params = {
        DClassify: this.dataForm.dclassify,
        DType: this.dataForm.dtype
      }

      console.log('dclassify:' + selVal)
      this.$api
        .selectDModel(params)
        .then(res => {
          if (res.Status === 1) {
            this.dmodels = res.Entity
            if (this.dmodels.indexOf(this.dataForm.dmodel) >= 0) {
            } else {
              this.dataForm.model = ''
            }
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    visibleChange(isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach(it => it.remove())
      }
    },
    selectionChange: function(selections) {
      this.selections = selections
      this.registList = []
      this.canUploadList = []
      this.canDeleteList = []
      this.canDeleteUploadList = []
      this.selections.forEach(dev => {
        if (dev.State === '可注册' || dev.State === '未通过') {
          this.registList.push(dev)
        }
        if (
          dev.IsUpload &&
          (dev.State === '可注册' || dev.State === '未通过')
        ) {
          this.canUploadList.push(dev)
        }
        if (
          dev.IsUpload &&
          dev.PCertificate !== null &&
          (dev.State === '可注册' || dev.State === '未通过')
        ) {
          this.canDeleteUploadList.push(dev)
        }
        if (dev.State === '可注册' || dev.State === '未通过') {
          this.canDeleteList.push(dev)
        }
      })
    },
    logout: function() {
      sessionStorage.removeItem('user')
      this.$router.push('/login')
    },
    dateFormat: function(row, column) {
      let time = dateFormat(row, column)
      return time
    }
  },
  components: {
    PictureList
  },
  mounted() {
    this.getlist()
    this.getDType()
  }
}



// WEBPACK FOOTER //
// ./src/views/Home.vue